import { KAPLAYCtx } from "kaplay";
import colors from "./colors";

export function creditScene(k: KAPLAYCtx) {
  k.scene("credit-scene", () => {
    k.loadMusic("star-wars", "./remove-later/star-wars.mp3");
    k.play("star-wars")
    // Create a gradient background
    k.add([
      k.rect(k.width(), k.height()),
      k.pos(0),
      k.color(colors[7]), // First color for the gradient
      // k.layer("bg"),
    ]);
    
    // // Overlay another rectangle to blend colors for gradient effect
    // k.add([
    //   k.rect(k.width(), k.height()),
    //   k.pos(0),
    //   k.color(colors[1]), // Second color for the gradient
    //   k.opacity(0.8),
    // ]);

    // Credit content
    const credits = {
      "credits": "CREDITS",
      "char-dsgn": "Character Designer:",
      "naufal": "Naufal Hanif Raharjo",
      "kosong": "",
      "back-dsgn": "Background Designer:",
      "dea": "Dea Alexandra Marselie",
      "kosong1": "",
      "ui-dsgn": "UI Designer:",
      "flo": "Florencia Yulianto",
      "kosong2": "",
      "snd-dsgn": "Sound Engineer:",
      "edi": "Edi Santoso",
      "kosong3": "",
      "prog": "Programmer:",
      "anton": "Anton - Marsiput.itch.io",
      "reza": "Reza Ainurrachman"
    };

    // Starting position of credits
    let yPos = k.height();

    let texts={}
    // Add scrolling animation for credits

    for (let key in credits) {
      const text = k.add([
        // k.text(credits[key], { size: key === "credits" ? 80 : 40, font: "monospace" }), // Larger size for title
        k.text(credits[key], { size: key === "credits" ? 80 : 40}), // Larger size for title
        k.pos(k.width() / 2, yPos),
        k.area(),
        k.color(key === "credits" ? colors[2] : colors[3]), // Different color for the title
        k.anchor("center"),
        k.layer("ui"),
      ]);

      texts[key]=text

      yPos += key === "credits" ? 100 : 50; // Add spacing between sections

      // Scroll effect
      // text.action(() => {
        // text.move(0, -50 * k.dt()); // Scroll upward
        // if (text.pos.y < -50) {
        //   text.destroy(); // Remove when out of screen
        // }
      // });
    }

    k.onUpdate(() => {
      // every 1s 
      for(let text in texts){
        texts[text].pos.y += -100 * k.dt() ;
      }
    });

    // Optional: Add background music (looping)
    // const bgMusic = k.play("credits-music", { loop: true, volume: 0.5 });

    // Stop the music when scene ends
    // k.action(() => {
    //   if (k.sceneEnded()) {
    //     bgMusic.stop();
    //   }
    // });

    // Allow skipping the credits with a keypress
    // k.onKeyPress("space", () => {
    //   k.go("jump-mechanism"); // Replace "next-scene" with your desired scene
    // });
  });
}
